<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-06-09 08:50:04
 * @FilePath: \sns-user-frontend\src\components\svgIcon.vue
 * @Description: svg图像组件
-->
<template>
  <svg 
    aria-hidden="true" 
    class="svg-icon" 
    :class="`${name}`" 
    :style="{
      color: color ? `${color} !important` : '',
      width: size,
      height: size
    }"
  >
    <use :xlink:href="symbolId"/>
  </svg>
</template>

<script setup>
import { computed, watch } from 'vue'

const props = defineProps({
  // 使用的svg图标名称，也就是svg文件名
  name: {
    type: String,
    required: true,
  },
  prefix: {
    type: String,
    default: 'icon',
  },
  color: {
    type: String,
    default: '',
  },
  size: {
    type: [String, Number]
  }
})


const symbolId = computed(() => `#${props.name}`)

</script>
<style scope>
/* 如需要动态切换svg-icon引入图片的颜色，需在调用方设置.svg-icon的color样式，仅支持整体颜色调整，不支持部分调整 */
.svg-icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
}
</style>